import { render } from "./UserSearch.vue?vue&type=template&id=2d0d5643&ts=true"
import script from "./UserSearch.vue?vue&type=script&lang=ts"
export * from "./UserSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__